export default "__VITE_ASSET__CQT$vXQO__"